import { Action } from "widgets-for-react"

export let get_lang_from_url = (path: Action<string>) => {
  let lang: string = ""
  if(window.location.pathname != "/"){
    let path_split = window.location.pathname.split("/")
    if(path_split.length > 1 && ['nl', 'en', 'asia', 'be-fr', 'be-nl', 'ng', 'id', 'cn'].includes(path_split[1])){
      lang = '/' + path_split[1] as string
    }
  }
  return lang + path(lang)
}
